module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/telegram-4a69a41c6fcb0483ba3ba98d343bb06f.svg";